<template>
  <div class="index">
    <!-- 新年烟花 -->
    <!-- <section class="bloom" v-if="bloom">
			<img class="main" src="./img/newyearboom1.gif">
			<img class="close" src="./img/close-icon.png" @click="bloom = !bloom">
		</section> -->
    <!-- 轮播组件 -->
    <div class="banner">
      <app-swiper></app-swiper>
    </div>
    <!-- 上方导航块 -->

    <div class="flex nav">
      <!-- <router-link class="navItem" tag="div" to="/aboutGolday">
 				<img class="pic" src="../img/nav1>
 				<span class="navName">关于金盛</span>
 			</router-link> -->
      <div class="navItem tv_icon_wrap">
        <a href="https://mod.goldayhk047.com/Mobile/Mlp/videoTv.html">
          <div>
            <!-- <img style="width: 0.6rem" src="./img/icon_shouye_TV.png" /> -->
            <img src="./img/newyear_icon2.png" />
          </div>
          <span class="navName">金盛TV</span>
        </a>
      </div>
      <div class="navItem">
        <a href="https://vip.goldayjs.com/Mobile/Index/login.html">
          <div class="pic">
            <!-- <img src="./img/icon_shouye_yonghuzhongxin.png" /> -->
            <img src="./img/newyear_icon5.png">
          </div>
          <span class="navName">用户中心</span>
        </a>
      </div>
      <router-link class="navItem" tag="div" to="/help">
        <div class="pic">
          <!-- <img src="./img/icon_shouye_changjianwenti.png" /> -->
          <img src="./img/newyear_icon7.png">
        </div>
        <span class="navName">常见问题</span>
      </router-link>
      <!-- <router-link class="navItem" tag="div" to="/trade/classify">
 				<div class="pic"><img src="./img/nav2.png"></div>
 				<span class="navName">交易产品</span>
 			</router-link> -->
      <!-- 2025年2月4日，此处未有跳转位置 -->
      <div class="navItem">
        <a href="https://wap.golday047.com/Mobile/Index/mock_account.html">
          <div class="pic">
            <!-- <img src="./img/icon_shouye_monin.png" /> -->
            <img src="./img/newyear_monijiaoyi.png" />
          </div>
          <span class="navName">模拟交易</span>
        </a>
      </div>

      <!-- 隐藏展开部分 -->
      <div v-show="nav_flat" class="folder_wrap cen_between">
        <router-link class="navItem" tag="div" to="/customer/discount">
          <div class="pic">
            <img src="./img/newyear_icon1.png">
            <!-- <img src="./img/icon_shouye_youhui.png" /> -->
          </div>

          <span class="navName">优惠活动</span>
        </router-link>
        <router-link class="navItem" tag="div" to="/customer/school">
          <div class="pic">
            <!-- <img src="./img/icon_shouye_ketang.png" /> -->
            <img src="./img/newyear_icon6.png">

          </div>
          <span class="navName">金盛课堂</span>
        </router-link>
        <!-- 换位 -->

        <router-link class="navItem" tag="div" to="/trade/rules">
          <div class="pic">
            <!-- <img src="./img/icon_shouye_jiaoyiguize.png" /> -->
            <img src="./img/newyear_trade.png" />
          </div>
          <span class="navName">交易规则</span>
        </router-link>
        <!-- <router-link class="navItem" tag="div" to="/user">
          <div class="pic"><img src="./img/nav8.png" /></div>
          <span class="navName">用户之声</span>
        </router-link> -->
        <router-link class="navItem" tag="div" to="/trade/download">
          <div class="pic">
            <!-- <img src="./img/icon_shouye_pingtaixiazai.png" /> -->
            <img src="./img/newyear_icon4.png">
          </div>
          <span class="navName">平台下载</span>
        </router-link>
      </div>
    </div>
    <!-- 导航栏折叠 -->
    <div class="nav_control_wrap cen" @click="nav_flat = !nav_flat">
      <span>{{
        nav_flat == false ? nav_flat_list[0].name : nav_flat_list[1].name
      }}</span>
      <img v-if="nav_flat == false" src="./img/icon_shouye_zhankai.png" alt="" />
      <img v-else src="./img/icon_shouye_shouqi.png" alt="" />
    </div>
    <!-- 账户总览-进度 -->
    <div class="award_wrap cen">
      <div class="account_progress_wrap">
        <!-- 领取进度，详情按钮 -->
        <div class="progress_info_wrap cen_between">
          <span class="progress_now">领取进度 1/4</span>
          <!-- 活动页面跳转的点击位置 -->
          <!-- 2025年7月25日 正式服详情跳转地址 -->
          <!-- <a href="https://m.goldayvip.com/Mobile/Mlp/hd202501_v1.html "> -->
          <!-- href="https://goldaycom-dev.jsjs047.com/Mobile/Mlp/hd202501_v1.html" -->
          <!-- 2025年7月25日 测试服详情跳转地址 -->
          <a href="https://m.goldayvip.com/Mobile/Mlp/hd202501_v1.html">
            <div class="progress_detail_wrap cen">
              <span>详情</span><img src="./img/icon_yhuzhongxin_more.png" alt="" />
            </div>
          </a>
        </div>
        <!-- 进度奖励介绍 -->
        <div class="progress_intro_wrap cen_between">
          <div class="intro_item intro_active">
            <div class="cen">
              <img class="intro_item_img" src="./img/icon_yhuzhongxin_kaihu.png" alt="" />
            </div>
            <div class="cen">
              <!-- 2025年7月29日 -->
              <span class="intro_msg bold_font">免费开户</span>
            </div>
            <div class="intro_dollar_wrap">
              <div class="intro_dollar"><span>￥</span></div>
              <div class="intro_mny"><span>8</span></div>
            </div>
          </div>

          <div class="intro_item">
            <div class="cen">
              <img class="intro_item_img" src="./img/icon_yhuzhongxin_renzheng.png" alt="" />
            </div>
            <div class="cen"><span class="intro_msg">实名认证</span></div>
            <div class="intro_dollar_wrap">
              <div class="intro_dollar"><span>￥</span></div>
              <div class="intro_mny"><span>20</span></div>
            </div>
          </div>

          <div class="intro_item">
            <div class="cen">
              <img class="intro_item_img" src="./img/icon_yhuzhongxin_zhuzi.png" alt="" />
            </div>
            <div class="cen"><span class="intro_msg">首次注资</span></div>
            <div class="intro_dollar_wrap">
              <div class="intro_dollar"><span>￥</span></div>
              <div class="intro_mny"><span>35</span></div>
            </div>
          </div>

          <div class="intro_item">
            <div class="cen">
              <img class="intro_item_img" src="./img/icon_yhuzhongxin_jiaoyi.png" alt="" />
            </div>
            <div class="cen">
              <span class="intro_msg" style="font-size: 0.23rem">交易0.3手</span>
            </div>
            <div class="intro_dollar_wrap">
              <div class="intro_dollar"><span>￥</span></div>
              <div class="intro_mny"><span>35</span></div>
            </div>
          </div>
        </div>

        <!-- 开户领红包 -->
        <div class="apply_account_wrap cen">
          <!-- 开户测试地址 -->
          <!-- https://goldaycom-dev.jsjs047.com/Mobile/Index/real_accountt.html -->
          <!-- 开户正式地址 -->
          <a href="https://m.goldayvip.com/Mobile/Index/real_accountt.html">
            <div class="apply_account_btn">
              <span>开户领红包</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- 直播gif -->

    <div class="live">
      <a href="http://www.golday666.com/mobile.php?fTag=1" target="_blank">
        <img class="live1" src="./img/zb2.gif" alt="" />
        <img class="live2" src="./img/zbj.gif" alt="" />
      </a>
    </div>

    <!-- 2025年7月16日 -->
    <!-- 开户按钮 -->
    <!-- <div class="flex openAccount">
      <a
        href="https://vip.goldayjs.com/Mobile/Activity/planmt.html"
        class="account"
        ><img src="./img/demoimg.png" alt="" /><span>模拟开户</span></a
      >
      <a href="javascript:;" class="account two" @click="goToAccount()"
        ><img src="./img/realimg.png" alt="" /><span>真实开户</span></a
      >
    </div> -->
    <!-- 最新公告 -->
    <div class="latest">
      <img src="./img/newtitle.png" />
      <router-link class="navItem" tag="div" to="/customer/notice">
        <img class="more" src="./img/more.png" />
      </router-link>
      <ul class="notice">
        <li v-for="(item, index) in notice" :key="index">
          <router-link :to="{
            path: '/detail',
            query: { id: item.id, title: '平台公告', type: 1 },
          }" @click.native="onNoticeClick(item.id)">
            <span>{{ index + 1 }}. {{ item.bt }}</span>
            <img v-if="index == 0 && !isNoticeRead(item.id)" class="new" src="./img/newgif.gif" />
            <i>{{ item.sj }}</i>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="flex pd30" v-if="graphs.length">
      <div class="data" :class="{ green: item[1] == 0 }" v-for="(item, index) in graphs" :key="index">
        <p class="name">{{ item[0] | toTxt }}</p>
        <p class="num">{{ item[2] }} {{ item[1] | getT }}</p>
        <p class="rate">{{ item[3] }}</p>
      </div>
    </div>
    <!-- 实时交易参考 -->
    <section class="section">
      <div class="titleBox1">
        <h2 class="bigtitle"><i></i> 实时交易参考 <i></i></h2>
      </div>
      <div class="tradeBox">
        <div class="ideaBox" v-for="(item, index) in teachers" :key="index">
          <div class="avator">
            <img :src="item.avatar" alt="" />
            <div class="info">
              <p class="tea">{{ item.account }}</p>
              <p class="time">{{ item.time }}</p>
            </div>
          </div>
          <p class="idea">{{ item.content }}</p>
        </div>
      </div>
    </section>
    <!-- 行业热点新闻 -->
    <section>
      <div class="titleBox2">
        <span :class="{ active: newsTabber === true }" @click="newsTab(1)">行业热点新闻</span>
        <span :class="{ active: newsTabber === false }" @click="newsTab(2)">实盘策略</span>
        <span><a href="https://gdnsapp.golday999.com/Mobile/Index/economic_calendar.html"
            target="_blank">财经日历</a></span>
      </div>
      <!-- 热点新闻 -->
      <div class="newsBox" v-if="newsTabber">
        <div class="newSwiper swiper1 swiper-container">
          <div class="swiper-wrapper">
            <router-link :to="{
              path: '/detail',
              query: { id: item.id, title: '热点新闻', type: 9 },
            }" tag="div" class="swiper-slide slide" v-for="(item, index) in newsSwiper" :key="index">
              <img :src="item.home_pic3" />

              <p class="newsTitle">{{ item.bt }}</p>
              <p class="newsDetail" v-html="item.zy"></p>
              <p class="newsTime">{{ item.sj }}</p>
            </router-link>
          </div>

          <div class="swiper-pagination pagination pagination1"></div>

          <div class="prev1"></div>
          <div class="next1"></div>
        </div>
      </div>
      <!-- 实盘侧罗 -->
      <div class="newsBox" v-if="!newsTabber">
        <div class="newSwiper swiper2 swiper-container">
          <div class="swiper-wrapper">
            <router-link :to="{
              path: '/detail',
              query: { id: item.id, title: '实盘策略', type: 7 },
            }" tag="div" class="swiper-slide slide" v-for="(item, index) in panSwiper" :key="index">
              <img :src="item.home_pic3" />
              <p class="newsTitle">{{ item.bt }}</p>
              <p class="newsDetail" v-html="item.zy"></p>
              <p class="newsTime">{{ item.sj }}</p>
            </router-link>
          </div>

          <div class="swiper-pagination pagination pagination2"></div>

          <div class="prev2"></div>
          <div class="next2"></div>
        </div>
      </div>
    </section>
    <!-- ——  平台下载 —— -->

    <section class="section">
      <div class="titleBox3">
        <h2 class="bigtitle"><i></i> 平台下载 <i></i></h2>
      </div>
      <div class="downloadTab">
        <div class="tab a1" :class="{ active: download === 1 }" @click="tabDownload(1)">
          <p class="p1">APP下载</p>
          <p class="p2">指尖交易让赚钱更简单</p>
        </div>
        <div class="tab" :class="{ active: download === 2 }" @click="tabDownload(2)">
          <p class="p1">MT4平台下载</p>
          <p class="p2">国际通用交易软件</p>
        </div>
        <div class="tab a2" :class="{ active: download === 3 }" @click="tabDownload(3)">
          <p class="p1">MT5平台下载</p>
          <p class="p2">更强大的交易系统</p>
        </div>
      </div>
      <div class="downloadBox">
        <div class="download" v-if="download == 1">
          <div>
            <p class="left">
              <b class="big">金盛贵金属APP</b>
              <b class="ruby">集开户、交易、存取款、实时报价、行情播报、专家分析、客服咨询</b>
              等功能于一身，随时随地手机交易，即时把握最佳盈利时机！
            </p>
            <img class="right" src="./img/downapp_2.png" alt="" />
          </div>
          <div class="flex appandriod">
            <span>
              <a href="https://goldayapi1.golday.info/Home/Qr/download_QR.html" target="_blank"><img
                  src="./img/apple.png" alt="" /> iOS 下载</a></span>
            <span>
              <a href="https://goldayapi1.golday.info/Home/Qr/download_QR.html" target="_blank"><img
                  src="./img/Android.png" alt="" /> Android 下载</a></span>
          </div>
        </div>
        <div class="download" v-if="download == 2">
          <img class="mt4img" src="./img/downmt4.jpg" alt="" />
          <div class="flex appandriod">
            <span>
              <a href="https://gdnsapp.golday999.com/Mobile/Activity/download_mt4_QR.html.html" target="_blank"><img
                  src="./img/apple.png" alt="" /> iOS 下载</a></span>
            <span>
              <a href="https://gdnsapp.golday999.com/Mobile/Activity/download_mt4_QR.html.html" target="_blank"><img
                  src="./img/Android.png" alt="" /> Android 下载</a></span>
          </div>
        </div>
        <div class="download" v-if="download == 3">
          <img class="mt4img" src="./img/jmt5.jpg" alt="" />
          <div class="flex appandriod">
            <span>
              <a href="https://gdnsapp.golday999.com/Mobile/Activity/download_mt5_QR.html" target="_blank"><img
                  src="./img/apple.png" alt="" /> iOS 下载</a></span>
            <span>
              <a href="https://gdnsapp.golday999.com/Mobile/Activity/download_mt5_QR.html" target="_blank"><img
                  src="./img/Android.png" alt="" /> Android 下载</a></span>
          </div>
        </div>
      </div>
    </section>
    <!-- ——  关于我们 —— -->
    <section class="section">
      <div class="titleBox4">
        <h2 class="bigtitle"><i></i> 关于我们 <i></i></h2>
      </div>
      <div class="aboutus">
        <h3>十二年稳健运营<br />香港黄金交易所AA类会员047号会员</h3>
        <p>
          金盛贵金属(vip.golday99.com)自成立以来，先后荣获
          【极具投资者信赖】、【行业类优秀企业奖】、【极具创新大奖】、【创新应用系统奖】、【年度优秀交易平台】等多项荣誉，足以彰显金盛贵金属的资质和综合实力，且单笔交易0.1手以上均提供【交易编码】，有据可查，保证所有交易公开透明，受到行业和投资者的充分认可与肯定。
        </p>
      </div>
      <img class="matop" src="./img/matop.jpg" alt="" />
      <div class="maflex" style="padding: 0.3rem 0 0 0.25rem">
        <div class="maitem">
          <img class="maimg" src="./img/bottomcode1.jpg" alt="" />

          <!-- <span class="copy copy1" data-clipboard-text="hkgolday" @click="copy('copy1')"></span> -->
        </div>
        <!-- <div class="maitem">
					<img class="maimg" src="./img/bb1.png" alt="">
					 
					  <span class="copy copy2" data-clipboard-text="800067971" @click="copy('copy2')"></span>  
				</div> -->
      </div>
    </section>

    <app-bottom></app-bottom>
  </div>
</template>

<script>
import swiper from "./components/swiper";
import bottom from "./components/Bottom";
import Swiper from "swiper";
import Clipboard from "clipboard";
import "swiper/dist/css/swiper.min.css";
export default {
  name: "index",
  data() {
    return {
      download: 1,
      newsTabber: true,
      notice: [],
      readNoticeIds: [],
      timeStartFormat: null,
      graphs: [],
      newsSwiper: [],
      panSwiper: [],
      teachers: [],
      copyTxt1: "hkgolday",
      copyTxt2: "800067971",
      bloom: true,
      //导航栏
      nav_flat: false,
      nav_flat_list: [
        {
          name: "展开全部",
          url: "./img/icon_shouye_zhankai.png",
        },
        {
          name: "收起隐藏",
          url: "./img/icon_shouye_shouqi.png",
        },
      ],
    };
  },
  created() {
    /*this.getTimeStamp(); */
    this.loadReadNoticeIds();
    this.getData();
    //this.fadeOut()
  },
  methods: {
    getCookie(name) {
      if (typeof document === "undefined") return "";
      const match = document.cookie.match(
        new RegExp("(^|;\\s*)" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\s*=\\s*([^;]*)")
      );
      return match ? decodeURIComponent(match[2]) : "";
    },
    setCookie(name, value, days = 365) {
      if (typeof document === "undefined") return;
      const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
        value
      )}; expires=${expires}; path=/`;
    },
    loadReadNoticeIds() {
      const raw = this.getCookie("golday_read_notice_ids");
      if (!raw) {
        this.readNoticeIds = [];
        return;
      }
      try {
        const arr = JSON.parse(raw);
        this.readNoticeIds = Array.isArray(arr) ? arr : [];
      } catch (e) {
        this.readNoticeIds = [];
      }
    },
    persistReadNoticeIds() {
      // 只存一小段，避免 cookie 过大
      const trimmed = (this.readNoticeIds || []).slice(0, 200);
      this.setCookie("golday_read_notice_ids", JSON.stringify(trimmed), 365);
    },
    isNoticeRead(id) {
      if (id === null || id === undefined) return false;
      const key = String(id);
      return (this.readNoticeIds || []).map(String).includes(key);
    },
    onNoticeClick(id) {
      if (id === null || id === undefined) return;
      const key = String(id);
      const list = (this.readNoticeIds || []).map(String);
      if (!list.includes(key)) {
        list.unshift(key);
        this.readNoticeIds = list;
        this.persistReadNoticeIds();
      }
    },
    goToAccount() {
      let link = "?" + window.location.href.toString().split("?")[1];
      window.open(
        "https://wap.golday047.com/Mobile/Index/real_accountt.html" + link
      );
    },
    fadeOut() {
      let _this = this;
      setTimeout(function () {
        _this.bloom = false;
      }, 5000);
    },
    copy(copyClass) {
      let clipboard = new Clipboard("." + copyClass);
      clipboard.on("success", (e) => {
        console.log("复制成功", e);
        alert("复制成功！");
        // 释放内存
        clipboard.destroy();
      });
    },
    newsTab(num) {
      if (num == 1) {
        this.newsTabber = true;
      } else {
        this.newsTabber = false;
      }
    },
    tabDownload(i) {
      this.download = i;
    },

    getData() {
      this.$http
        .post("/Mobile/Index/ptgg", 1) //最新公告
        .then((res) => {
          this.notice = res.data.slice(0, 3).map((v) => {
            let date = v.sj.split("-");
            v.sj = date[2] + "/" + date[1];
            return v;
          });
        });

      this.$http
        .get("/Home/GetScript/getMGraphs") //实时行情
        .then((res) => {
          let obj = res;
          console.log(obj);
          for (let i in obj) {
            if (i.indexOf(2) != -1) {
              console.log(obj[i][1]);
              if (obj[i][1].indexOf("-") != -1) {
                obj[i].unshift(0);
              } else {
                obj[i].unshift(1);
              }

              obj[i].unshift(i);
              this.graphs.push(obj[i]);
            }
          }
        });

      this.$http
        .get("/Home/Index2020/viewpoint") //实时交易
        .then((res) => {
          this.teachers = res.data.records;
        });
      this.$http
        .post("/Mobile/Index/hyrdxw", 1) //行情热点
        .then((res) => {
          this.newsSwiper = res.data.slice(0, 3);
          this.$nextTick(() => {
            // DOM更新了
            // swiper重新初始化
            /*eslint-disable no-new */
            let mySwiper1 = new Swiper(".swiper1", {
              autoplay: 2000,
              pagination: ".pagination1",
              prevButton: ".prev1",
              nextButton: ".next1",
            });
          });
        });
      this.$http
        .post("/Mobile/Index/spcl", 1) //实盘策略
        .then((res) => {
          this.panSwiper = res.data.slice(0, 3);
          this.$nextTick(() => {
            // DOM更新了
            // swiper重新初始化
            /* eslint-disable no-new */
            let mySwiper2 = new Swiper(".swiper2", {
              autoplay: 2000,
              pagination: ".pagination2",
              prevButton: ".prev2",
              nextButton: ".next2",
            });
          });
        });
    },
    /*getTimeStamp(){
        let timeStart;
        let curTime = new Date().getTime();
        let startDate = curTime - (7 * 3600 * 24 * 1000);
        startDate = new Date(startDate).toLocaleDateString();
        if(startDate.indexOf("年") >-1){ 
          startDate = startDate.replace(/年/g,'\/');  
        }
        if(startDate.indexOf("月") >-1){
          startDate = startDate.replace(/月/g,'\/');   
        }
        if(startDate.indexOf("日") >-1){
          startDate = startDate.replace(/日/g,'');    
        }
        startDate = startDate.split("/");  
        timeStart=startDate.join("-"); 
        this.timeStartFormat= timeStart;
      }*/
  },
  filters: {
    toTxt: (value) => {
      let txt;
      if (value == "QLLG2") {
        txt = "伦敦金";
      } else if (value == "QLLS2") {
        txt = "伦敦银";
      } else if (value == "QUSDX2") {
        txt = "美元指数";
      } else if (value == "QC2L") {
        txt = "纽约原油";
      }
      return txt;
    },
    getT: (value) => {
      if (value == 1) {
        return "↑";
      } else if (value == 0) {
        return "↓";
      }
    },
  },
  components: {
    "app-swiper": swiper,
    "app-bottom": bottom,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.bloom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 101;
}

.bloom .main {
  width: 7.5rem;
  position: absolute;
  top: 2.1rem;
  left: 50%;
  transform: translateX(-50%);
}

.bloom .close {
  width: 0.48rem;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
}

.navItem img {
  width: 1rem;
  height: 1rem;
  display: block;
  transition: transform 0.3s ease;
}

.pagination {
  top: 1.8rem;
  left: auto !important;
  right: 0.3rem;
  width: 2rem !important;
  height: 1rem;
}

.swiper-pagination .swiper-pagination-bullet-active {
  background: #ff5555;
}

.swiper-pagination span {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 30px;
  opacity: 1;
  margin: 0 0.1rem;
  background: #dee0e8;
}

.prev1,
.prev2 {
  width: 0.27rem;
  height: 0.49rem;
  background: url("./img/swiperLeft.png") no-repeat top center;
  background-size: 0.27rem 0.49rem;
  left: 10px;
  top: 1.7rem;
  position: absolute;
  right: auto;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
}

.next1,
.next2 {
  width: 0.27rem;
  height: 0.49rem;
  background: url("./img/swiperLeft.png") no-repeat top center;
  background-size: 0.27rem 0.49rem;
  transform: rotate(180deg);
  right: 10px;
  top: 1.7rem;
  position: absolute;

  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
}

.titleBox2 {
  width: 100%;
  height: 1.25rem;
  background: url("./img/bgnews.jpg") no-repeat top center;
  background-size: 7.5rem 1.25rem;
  display: flex;
  padding: 0 0.3rem;
  justify-content: space-between;
  align-items: center;
}

.titleBox2 span {
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.32rem;
  color: #c2b5a5;
  font-weight: bold;
}

.titleBox2 span.active {
  color: #fff;
  border-bottom: 0.04rem solid #c2b5a5;
}

.newsBox {
  width: 100%;
  padding: 0.3rem 0.3rem 0.4rem;
  background: #fff;
  margin-bottom: 0.2rem;
}

.newsBox .newSwiper {
  width: 6.9rem;
  height: 6rem;
}

.newSwiper a img {
  width: 6.9rem;
  height: 3rem;
}

.newsBox p {
  color: #333;
  font-size: 0.28rem;
}

.newsTitle {
  font-weight: bold;
  line-height: 0.5rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.newsDetail {
  line-height: 0.42rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.newsBox .newsTime {
  font-size: 0.26rem;
  margin-top: 0.1rem;
  color: #999;
  text-align: right;
}

.tradeBox {
  width: 100%;
  padding: 0 0.3rem 0rem 0.3rem;
  height: 6.55rem;
  overflow-y: scroll;
}

.tradeBox .ideaBox {
  width: 100%;
  padding-bottom: 0.3rem;
  border-bottom: 1px solid #e8e8e8;
}

.ideaBox .avator img {
  width: 0.8rem;
  height: 0.8rem;
  display: inline-block;
  vertical-align: middle;
}

.ideaBox .avator .info {
  display: inline-block;
  vertical-align: middle;
}

.ideaBox .info .tea {
  font-size: 0.3rem;
  color: #333333;
}

.ideaBox .info .time {
  font-size: 0.24rem;
  color: #999;
  line-height: 0.48rem;
}

.ideaBox .idea {
  font-size: 0.28rem;
  color: #333333;
  line-height: 0.42rem;
}

.downloadTab {
  width: 7rem;
  height: 1rem;
  margin: 0.3rem auto;
  background-color: #ffffff;
  border-radius: 7px;
  border: solid 0.02rem #ff5555;
  font-size: 0;
}

.downloadTab .tab {
  vertical-align: middle;
  display: inline-block;
  width: 33.333%;
  height: 0.98rem;
  text-align: center;
  padding-top: 0.1rem;
  color: #ff5555;
}

.downloadTab .tab .p2 {
  font-size: 0.22rem;
  opacity: 0.8;
}

.downloadTab .tab .p1 {
  font-size: 0.32rem;
}

.downloadTab .tab.active {
  background-color: #ff5555;
  color: #fff;
}

.downloadTab .a1.active {
  border-radius: 7px 0rem 0rem 7px;
}

.downloadTab .a2.active {
  border-radius: 0px 7px 7px 0;
}

.download {
  width: 100%;
  height: 5.43rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.3rem;
  flex-wrap: wrap;
}

.download .mt4img {
  width: 6.9rem;
}

.download .right {
  width: 3.44rem;
  height: 4.3rem;
  vertical-align: middle;
}

.download .left {
  width: 3rem;
  font-size: 0.28rem;
  color: #333;
  vertical-align: middle;
  line-height: 0.45rem;
  display: inline-block;
}

.download .big {
  font-size: 0.4rem;
  color: #333;
}

.download .ruby {
  font-size: 0.28rem;
  color: #ff5555;
}

.appandriod {
  width: 100%;
  margin-top: 0.3rem;
}

.appandriod span {
  width: 3.35rem;
  height: 0.78rem;
  line-height: 0.78rem;
  text-align: center;
  font-size: 0.3rem;
  color: #fff;
  background-color: #cca95e;
  border-radius: 0.06rem;
}

.appandriod img {
  width: 0.28rem;
  height: 0.34rem;
  vertical-align: middle;
  margin-right: 0.1rem;
}

.index {
  position: relative;
  margin-top: 0.6rem;
}

.section {
  width: 100%;
  margin: 0 auto 0.2rem;
  background: #fff;
  padding-bottom: 0.4rem;
}

.pd30 {
  padding: 0.2rem 0.3rem;
}

.nav {
  width: 100%;
  padding: 0.3rem 0.3rem 0.3rem;
  background: #fff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
}

.nav .pic {
  width: 1rem;
  height: 1rem;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.nav .pic img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  vertical-align: middle;
  transition: transform 0.3s ease;
}

.nav .navItem {
  width: 1.5rem;
  text-align: center;
  font-size: 0;
  margin-top: 0.45rem;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nav .navItem:active {
  transform: scale(0.95);
  opacity: 0.8;
}

.nav .navItem a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-decoration: none;
  color: inherit;
}

.nav .navItem>div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.nav .navName {
  font-size: 0.26rem;
  margin-top: 0.25rem;
  color: #333;
  line-height: 1.2;
  word-break: keep-all;
  white-space: nowrap;
}

.latest {
  padding: 0.3rem 0;
  width: 100%;
  background: #fff;
  margin-bottom: 0.2rem;
  position: relative;
}

.latest img {
  width: 1.5rem;
  height: 0.31rem;
  margin: 0 0 0.15rem 0.3rem;
  display: block;
}

.latest .more {
  width: 0.67rem;
  height: 0.24rem;
  position: absolute;
  right: 0.3rem;
  top: 0.3rem;
}

.notice {
  width: 100%;
  background-color: #fff;
  color: #333;
  padding: 0 0.3rem;
  position: relative;
}

.notice a {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.notice li {
  width: 100%;
  line-height: 0.55rem;
  position: relative;
}

.notice li .new {
  position: absolute;
  width: 0.7rem;
  height: 0.32rem;
  left: 4.7rem;
  margin: 0;
  top: 0.15rem;
}

.notice li span {
  font-size: 0.26rem;
  width: 4.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice li i {
  font-size: 0.26rem;
  color: #9b9b9b;
}

.bigtitle {
  font-size: 0.44rem;
  color: #fff;
  text-align: center;
  text-align: center;
  padding: 0.4rem 0;
  position: relative;
}

.bigtitle i {
  display: inline-block;
  width: 0.7rem;
  height: 0.02rem;
  background-color: #fff;
  border-radius: 0.01rem;
  vertical-align: middle;
}

.data {
  width: 2.2rem;
  height: 1.31rem;
  background-color: #ffffff;
  border-radius: 0.06rem;
  text-align: center;
  padding: 0.15rem 0;
  color: #ff3334;
}

.data.green {
  color: #33cc99;
}

.data .name {
  font-size: 0.24rem;
  color: #333;
}

.data .num {
  font-size: 0.32rem;
  /* margin-top:.1rem; */
  font-weight: bold;
}

.data .rate {
  font-size: 0.22rem;
}

.banner {
  width: 100%;
  height: 3.6rem;
  position: relative;
}

.live {
  width: 1.3rem;
  height: 1.3rem;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0rem 0rem 0.1rem 0rem rgba(143, 134, 119, 0.7);
  border-radius: 0.24rem;
  position: fixed;
  right: 0.1rem;
  top: 5rem;
  text-align: center;
  padding-top: 0.17rem;
  z-index: 100;
}

.live .live1 {
  width: 1.3rem;
  display: block;
  margin: 0 auto;
}

.live .live2 {
  width: 0.9rem;
  display: block;
  margin: 0 auto;
}

.openAccount {
  width: 100%;
  padding: 0.2rem 0.3rem;
}

.openAccount img {
  width: 0.37rem;
  margin-right: 0.1rem;
  vertical-align: middle;
}

.openAccount a {
  font-size: 0;
}

.openAccount .account {
  width: 3.35rem;
  height: 0.78rem;
  box-shadow: 0rem 0.05rem 0rem 0rem #b58f3f;
  border-radius: 3px;
  font-size: 0.3rem;
  color: #fff;
  text-align: center;
  line-height: 0.8rem;
  background: #cca95e url("./img/demo.png") no-repeat left top;
  background-size: 0.7rem 0.38rem;
}

.openAccount a.two {
  background: #ff5555 url("./img/real.png") no-repeat right top;
  background-size: 1rem 0.38rem;
  box-shadow: 0rem 0.05rem 0rem 0rem #de3535;
  padding-right: 0.3rem;
}

.titleBox1 {
  width: 100%;
  background: url("./img/bgtrade.jpg") no-repeat top center;
  background-size: 7.5rem 1.25rem;
}

.titleBox3 {
  width: 100%;
  background: url("./img/bgdownload.jpg") no-repeat top center;
  background-size: 7.5rem 1.25rem;
}

.aboutus {
  padding: 0.3rem;
  color: #333;
}

.aboutus h3 {
  font-size: 0.36rem;
  line-height: 0.48rem;
}

.aboutus p {
  font-size: 0.28rem;
  line-height: 0.42rem;
  margin-top: 0.3rem;
}

.titleBox4 {
  width: 100%;
  background: url("./img/bgaboutus.jpg") no-repeat top center;
  background-size: 7.5rem 1.25rem;
}

.show {
  display: block !important;
}

.matop {
  width: 4.46rem;
  height: 0.64rem;
  margin: 0 auto;
  display: block;
}

.maflex {
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0.37rem 0;
}

.maitem {
  position: relative;
}

.copy {
  position: absolute;
  left: 1rem;
  bottom: 0.8rem;
  width: 2rem;
  height: 0.5rem;
}

.maimg {
  width: 7rem;
  /* height: 3.9rem; */
}

/* 2025年1月27日 账户总览，进度 */
.cen {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cen_between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.account_progress_wrap {
  position: relative;
  width: 7.1rem;
  height: 3.8rem;
  background: url("./img/bg_yhzx_shouye_hd_beijing.png") no-repeat center;
  background-size: 100% 100%;
  padding: 0.3rem 0.2rem 0.2rem;
}

.progress_info_wrap {
  padding-left: 3.35rem;
}

.progress_now {
  font-size: 0.24rem;
  color: #fcab2e;
}

.progress_detail_wrap {
  gap: 0.12rem;
}

.progress_detail_wrap span {
  font-size: 0.24rem;
  color: #bda168;
}

.progress_detail_wrap img {
  width: 0.1rem;
  transform: translateY(0.03rem);
}

.intro_item {
  position: relative;
  width: 1.56rem;
  height: 1.92rem;
  background: url("./img/yhzx_wxz_item_bg.png") no-repeat center;
  background-size: 100% 100%;
  padding: 0.22rem 0.23rem 0.15rem;
  margin-top: 0.3rem;
}

.intro_active {
  background: url("./img/yhzx_hd_xuanzhongkuang.png") no-repeat center;
  background-size: 100% 100%;
}

.intro_msg {
  font-size: 0.24rem;
  margin: 0.12rem 0 0.05rem;
  color: #555555;
}

.intro_dollar span {
  font-size: 0.26rem;
  color: #fcab2e;
}

.intro_dollar {
  display: flex;
  flex-direction: column-reverse;
  padding-bottom: 0.02rem;
}

.intro_mny span {
  font-size: 0.36rem;
  color: #fcab2e;
}

.intro_dollar_wrap {
  display: flex;
  justify-content: center;
}

.intro_item_img {
  width: 0.42rem;
}

.apply_account_wrap {
  margin-top: 0.05rem;
}

.apply_account_btn {
  font: initial;
  padding: 0.15rem 0.68rem;
  background-image: linear-gradient(90deg, #ff9118 0%, #ff5f18 100%);
  border-radius: 0.35rem;
}

.apply_account_btn span {
  font-size: 0.26rem;
  color: #ffffff;
}

.award_wrap {
  width: 100%;
  background: url("./img/bg_yhzx_shouye_beijing.jpg") no-repeat center;
  padding: 0.2rem;
}

.intro_dollar_wrap div {
  font: initial;
}

.nav_control_wrap {
  width: 100%;
  padding: 0 0.3rem 0.3rem;
  background: #fff;
  font: initial;
}

.nav_control_wrap span {
  color: #999999;
  font-size: 0.24rem;
  margin-right: 0.05rem;
}

.nav_control_wrap img {
  width: 0.18rem;
}

.folder_wrap {
  width: 100%;
}

.tv_icon_wrap {
  position: relative;
}

.tv_icon_wrap>a>div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  margin: 0 auto;
}

.tv_icon_wrap>a>div img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* .tv_icon_wrap ::before {
  position: absolute;
  content: "";
  top: -0.2rem;
  right: 0.05rem;
  width: 0.79rem;
  height: 0.26rem;
  background-image: url("./img/icon_shouye_reyi.png");
  background-size: cover;
  background-repeat: no-repeat;
} */

/* 2025年7月29日 */
.bold_font {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue